import { useState, useEffect } from "react";
import { initializeLibraryI18n, i18nLibraryInstance } from "./library.js";
import "i18next";
import "../../../../external/_pnpm/i18next-icu@2.3.0_intl-messageformat@10.5.14/external/i18next-icu/dist/es/index.js";
import "react-i18next";
function getI18nInstance() {
  return i18nLibraryInstance;
}
const useI18n = (currentLanguage) => {
  const i18nInstance = getI18nInstance();
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    if (i18nInstance.isInitialized) {
      setIsInitialized(true);
      return;
    }
    const initialize = async () => {
      await initializeLibraryI18n();
      setIsInitialized(true);
    };
    initialize();
  }, [i18nInstance]);
  useEffect(() => {
    if (currentLanguage && isInitialized) {
      i18nInstance.changeLanguage(currentLanguage);
    }
  }, [currentLanguage, isInitialized, i18nInstance]);
  return {
    isInitialized,
    i18n: i18nInstance
  };
};
export {
  useI18n
};
//# sourceMappingURL=hook.js.map
